import { Login } from "pages/Auth/Login";
import { Register } from "pages/Auth/Register";
import { Reset } from "pages/Auth/Reset";
import { Navigate, Route, Routes } from "react-router-dom";

export function AuthRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/register/:slug" element={<Register />} />
      <Route path="/login/:slug" element={<Login />} />
      <Route path="/reset/:slug" element={<Reset />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
